import { render } from "./EditarPerfilUser.vue?vue&type=template&id=6146d29c"
import script from "./EditarPerfilUser.vue?vue&type=script&lang=js"
export * from "./EditarPerfilUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__